import React from "react";
import { Outlet } from "react-router-dom";
import "../../assets/user/css/auth.css";
import "../../assets/css/caregiver.css";
import "../../assets/css/careseeker.css";

export const UserAuthApp = () => {
  return (
    <>
      <Outlet />
    </>
  );
};
